<template>
  <div id="gallery">
    <a
      v-for="(image, key) in images"
      :key="key"
      :href="image.largeURL"
      :data-pswp-width="image.width"
      :data-pswp-height="image.height"
      target="_blank"
      rel="noreferrer"
    >
    </a>
  </div>
</template>

<script>
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import imagesDE from "../../GalleryDe.json";
import imagesEN from "../../GalleryEn.json";

const leftArrowSVGString =
  '<?xml version="1.0" encoding="UTF-8"?>\n' +
  '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 39">\n' +
  "  <defs>\n" +
  "    <style>\n" +
  "      .cls-1 {\n" +
  "        fill: #ded6cd;\n" +
  "      }\n" +
  "    </style>\n" +
  "  </defs>\n" +
  '  <path class="cls-1" d="M2.15,18.81l-.68,.71,16.72,17.46c.38,.4,1.02,.41,1.41,.03,.4-.38,.41-1.02,.03-1.41L5.2,20.52H39.91c.55,0,1-.45,1-1s-.45-1-1-1H5.2L19.64,3.44c.38-.4,.37-1.03-.03-1.41-.19-.19-.44-.28-.69-.28-.26,0-.53,.1-.72,.31L2.15,18.81s0,0,0,0Z"/>\n' +
  "</svg>";
const rightArrowSVGString =
  '<?xml version="1.0" encoding="UTF-8"?>\n' +
  '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 39">\n' +
  "  <defs>\n" +
  "    <style>\n" +
  "      .cls-1 {\n" +
  "        fill: #ded6cd;\n" +
  "      }\n" +
  "    </style>\n" +
  "  </defs>\n" +
  '  <path class="cls-1" d="M40.23,20.22l.68-.71L24.19,2.05c-.38-.4-1.02-.41-1.41-.03-.4,.38-.41,1.02-.03,1.41l14.44,15.08H2.47c-.55,0-1,.45-1,1s.45,1,1,1H37.18l-14.44,15.08c-.38,.4-.37,1.03,.03,1.41,.19,.19,.44,.28,.69,.28,.26,0,.53-.1,.72-.31l16.04-16.75s0,0,0,0Z"/>\n' +
  "</svg>";
const zoomSVG = "";
const closeSVG =
  '<svg version="1.1" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n' +
  '\t x="0px" y="0px" viewBox="0 0 100 25" overflow="visible" xml:space="preserve">\n' +
  "\t <defs>\n" +
  "    <style>\n" +
  "      .cls-1 {\n" +
  "        fill: #ded6cd;\n" +
  "      }\n" +
  "    </style>\n" +
  "  </defs>\n" +
  "<g>\n" +
  "\t<g>\n" +
  "\t\t<g>\n" +
  '\t\t\t<polygon class="cls-1" points="24.6,2.5 23.1,1.1 12.9,11.4 2.6,1.1 1.2,2.5 11.5,12.8 1.2,23.1 2.6,24.5 12.9,14.2 23.1,24.5 24.6,23.1\n' +
  '\t\t\t\t14.3,12.8 \t\t\t"/>\n' +
  '\t\t\t<path class="cls-1" d="M46.1,21.2c4.2,0,6.9-2.7,7.4-7h-1.9c-0.5,3.4-2.5,5.3-5.5,5.3c-3.5,0-5.6-2.6-5.6-7c0-4.5,2.1-7.1,5.7-7.1\n' +
  '\t\t\t\tc3,0,5,1.8,5.4,4.8h1.9c-0.4-4.1-3.1-6.5-7.3-6.5c-4.8,0-7.7,3.3-7.7,8.8C38.5,18,41.4,21.2,46.1,21.2z"/>\n' +
  '\t\t\t<rect class="cls-1" x="56.2" y="3.7" width="1.9" height="17.2"/>\n' +
  '\t\t\t<path class="cls-1" d="M66.7,19.7c-2.7,0-4.1-1.8-4.1-4.8s1.4-4.8,4.1-4.8s4.1,1.8,4.1,4.8S69.4,19.7,66.7,19.7z M66.7,21.2c3.9,0,6-2.3,6-6.2\n' +
  '\t\t\t\tc0-3.9-2.1-6.2-6-6.2c-3.9,0-6,2.3-6,6.2C60.7,18.9,62.8,21.2,66.7,21.2z"/>\n' +
  '\t\t\t<path class="cls-1" d="M80.3,21.2c2.9,0,5.1-1.2,5.1-3.6c0-1.9-1.3-2.8-4.9-3.5c-2.7-0.5-3.5-1-3.5-2c0-1.3,1.4-1.9,3-1.9\n' +
  "\t\t\t\tc2.1,0,3.2,0.9,3.3,2.9h1.8C85.1,10.3,83,8.7,80,8.7c-2.6,0-4.9,1.1-4.9,3.5c0,1.8,1.3,2.7,4.9,3.3c2.7,0.5,3.5,1,3.5,2.1\n" +
  '\t\t\t\tc0,1.4-1.3,2.1-3.2,2.1c-2.4,0-3.7-1-3.8-3h-1.8C74.8,19.6,76.9,21.2,80.3,21.2z"/>\n' +
  '\t\t\t<path class="cls-1" d="M93.2,10.2c2.3,0,3.6,1.2,3.7,3.5h-7.6C89.7,11.4,91,10.2,93.2,10.2z M98.8,14.5c0-3.8-2.1-5.8-5.7-5.8\n' +
  "\t\t\t\tc-3.6,0-5.8,2.2-5.8,6.2c0,4.1,2.1,6.3,5.8,6.3c3.1,0,5.1-1.6,5.5-4.6h-1.8c-0.3,2-1.6,3.1-3.7,3.1c-2.5,0-3.9-1.6-4-4.5h9.6\n" +
  '\t\t\t\tV14.5z"/>\n' +
  "\t\t</g>\n" +
  "\t</g>\n" +
  "</g>\n" +
  "</svg>";

export default {
  name: "SimpleGallery",

  props: {},
  data() {
    const isEnglish = window.location.pathname.startsWith("/en");
    if (isEnglish) {
      return {
        images: imagesEN,
      };
    }
    return {
      images: imagesDE,
    };
  },
  mounted() {
    this.emitter.on("open-gallery", (evt) => {
      this.open();
    });

    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: "#gallery",
        children: "a",
        preloadFirstSlide: true,
        bgOpacity: 1,
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        zoomSVG: zoomSVG,
        closeSVG: closeSVG,
        pswpModule: () => import("photoswipe"),
      });
      this.lightbox.init();

      this.lightbox.on("change", () => {
        // triggers when slide is switched, and at initialization
        let currentImage = this.images[this.lightbox.pswp.currSlide.index];
        let galleryElement = document.querySelector(".pswp");

        if (currentImage.background === "light") {
          galleryElement.classList.remove("dark-bg");
          galleryElement.classList.add("light-bg");
        }
        if (currentImage.background === "dark") {
          galleryElement.classList.remove("light-bg");
          galleryElement.classList.add("dark-bg");
        }
      });

      this.lightbox.on("close", () => {
        this.emitter.emit("close-gallery");
      });
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
  methods: {
    open() {
      this.lightbox.loadAndOpen(0, {
        gallery: document.querySelector("#gallery"),
      });
    },
  },
};
</script>

<style>
.light-bg .pswp__bg {
  background: #ffffff;
}
.light-bg .pswp__counter {
  color: #000000;
}
.light-bg .cls-1 {
  fill: #000000;
}
.dark-bg .cls-1 {
  fill: #ffffff;
}

.dark-bg .pswp__bg {
  background: #000000;
}

.pswp__button--arrow--prev {
  left: 25px;
}
.pswp__button--arrow--next {
  right: 25px;
}

@media (max-width: 640px) {
  .pswp__button--arrow--prev,
  .pswp__button--arrow--next {
    display: none;
  }
}

.pswp__button--close {
  right: 25px;
  top: 5px;
  width: 100px;
}

.pswp__counter {
  text-shadow: none;
}
</style>
